import { useState, useEffect } from 'react';

const Noticias = () => {
  const [noticiaActiva, setNoticiaActiva] = useState(null);
  const [noticias, setNoticias] = useState([]);

  useEffect(() => {
    const cargarNoticias = async () => {
      try {
        const res = await fetch('https://logia-production-725b.up.railway.app/api/noticias');
        const data = await res.json();
        if (data.success) {
          setNoticias(data.data);
        }
      } catch (error) {
        console.error("Error cargando noticias:", error);
      }
    };
    cargarNoticias();
    window.scrollTo(0, 0);
  }, []);

  const formatearFecha = (fecha) => {
    return new Date(fecha).toLocaleDateString('es-PE', { day: '2-digit', month: 'long', year: 'numeric' });
  };

  const obtenerResumen = (texto) => {
    if (!texto) return '';
    return texto.length > 200 ? texto.substring(0, 200) + '...' : texto;
  };

  // Asignamos la más reciente como destacada y las demás al grid
  const noticiaPrincipal = noticias.length > 0 ? noticias[0] : null;
  const noticiasRestantes = noticias.length > 1 ? noticias.slice(1) : [];

  // --- VISTA 2: DETALLE DE LA NOTICIA ---
  if (noticiaActiva) {
    return (
      <div className="min-h-screen bg-[#050505] text-white font-sans pt-24 pb-24 selection:bg-[#C5A059] selection:text-[#050505]">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 pt-12 animate-fade-in">
          
          <button 
            onClick={() => setNoticiaActiva(null)}
            className="flex items-center gap-2 text-[#C5A059] text-xs tracking-widest uppercase hover:text-white transition-colors mb-12 group"
          >
            <svg className="w-4 h-4 transform group-hover:-translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M7 16l-4-4m0 0l4-4m-4 4h18" />
            </svg>
            Volver a Noticias
          </button>

          <div className="mb-10 text-center">
            <div className="flex items-center justify-center gap-4 mb-6">
              <span className="text-[#050505] bg-[#C5A059] px-3 py-1 text-[10px] tracking-[0.2em] uppercase font-bold">
                Actualidad
              </span>
              <span className="text-gray-500 text-[11px] tracking-widest uppercase font-mono">
                {formatearFecha(noticiaActiva.fecha_creacion)}
              </span>
            </div>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-8">
              {noticiaActiva.titulo}
            </h1>
          </div>

          <div className="w-full aspect-[16/9] md:aspect-[21/9] bg-gray-900 border border-white/10 shadow-2xl p-2 bg-[#0a0a0a] mb-12">
            <img 
              src={noticiaActiva.foto_url || "https://images.unsplash.com/photo-1507676184212-d0350eb05dda?w=1200"} 
              alt={noticiaActiva.titulo} 
              className="w-full h-full object-cover opacity-90"
            />
          </div>

          <div className="prose prose-invert prose-lg max-w-none text-gray-300 font-light leading-relaxed text-justify mx-auto">
            {(noticiaActiva.articulo).split('\n\n').map((parrafo, idx) => {
              if (idx === 0) {
                return (
                  <p key={idx} className="text-gray-300 font-light leading-relaxed text-lg md:text-xl text-justify mb-8">
                    <span className="float-left text-7xl md:text-8xl text-[#C5A059] font-serif pr-4 leading-[0.8] mt-2 drop-shadow-md">
                      {parrafo.charAt(0)}
                    </span>
                    {parrafo.substring(1)}
                  </p>
                );
              }
              return (
                <p key={idx} className="text-gray-400 font-light leading-relaxed text-base md:text-lg text-justify mb-8">
                  {parrafo}
                </p>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  // --- VISTA 1: LISTADO DE NOTICIAS ---
  return (
    <div className="min-h-screen bg-[#050505] text-white selection:bg-[#C5A059] selection:text-[#050505] font-sans pt-24 flex flex-col animate-fade-in">
      
      {/* Hero Section */}
      <section className="relative w-full pt-32 pb-16 md:pt-40 md:pb-24 flex flex-col items-center justify-center overflow-hidden border-b border-white/5">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1589829085413-56de8ae18c73?q=80')] bg-cover bg-center bg-no-repeat opacity-20"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/90 via-[#050505]/60 to-[#050505]"></div>
        <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
          <p className="text-[#C5A059] tracking-[0.4em] uppercase text-xs md:text-sm font-light mb-4">Actualidad</p>
          <h1 className="font-serif text-4xl md:text-6xl font-normal text-white tracking-tight drop-shadow-lg mb-6">Noticias y Comunicados</h1>
          <p className="text-gray-400 font-light text-sm md:text-base max-w-2xl mx-auto">
            Manténgase informado sobre las actividades jurisdiccionales, ceremonias y comunicados oficiales.
          </p>
        </div>
      </section>

      <section className="relative z-20 max-w-[90rem] mx-auto px-6 lg:px-12 py-16 md:py-24 flex-grow w-full">
        
        {/* ARTÍCULO DESTACADO */}
        {noticiaPrincipal && (
          <div className="mb-20 group cursor-pointer" onClick={() => setNoticiaActiva(noticiaPrincipal)}>
            <div className="flex flex-col lg:flex-row gap-0 bg-[#0a0a0a] border border-white/5 shadow-2xl overflow-hidden hover:border-[#C5A059]/40 transition-colors duration-500">
              <div className="w-full lg:w-1/2 aspect-video lg:aspect-auto relative overflow-hidden bg-gray-900 border-r border-white/5">
                <img 
                  src={noticiaPrincipal.foto_url || "https://images.unsplash.com/photo-1541888086925-921eb234c900?w=800"} 
                  alt={noticiaPrincipal.titulo} 
                  className="w-full h-full object-cover opacity-70 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
                />
              </div>
              <div className="w-full lg:w-1/2 p-8 md:p-16 flex flex-col justify-center">
                <div className="flex items-center gap-4 mb-6">
                  <span className="text-[#C5A059] text-[10px] tracking-[0.2em] uppercase border border-[#C5A059]/30 px-3 py-1">Destacado</span>
                  <span className="text-gray-500 text-[10px] tracking-widest uppercase font-mono">{formatearFecha(noticiaPrincipal.fecha_creacion)}</span>
                </div>
                <h2 className="font-serif text-3xl md:text-5xl text-white mb-6 leading-tight group-hover:text-[#C5A059] transition-colors duration-300">
                  {noticiaPrincipal.titulo}
                </h2>
                <p className="text-gray-300 font-light text-base md:text-lg leading-relaxed mb-8">
                  {obtenerResumen(noticiaPrincipal.articulo)}
                </p>
                <div className="mt-auto">
                  <span className="inline-flex items-center gap-2 text-xs tracking-widest uppercase text-[#C5A059] border-b border-[#C5A059] pb-1">Leer Nota Completa</span>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="flex items-center gap-4 mb-12">
          <h3 className="font-serif text-2xl md:text-3xl text-white">Últimas Publicaciones</h3>
          <div className="h-[1px] flex-grow bg-gradient-to-r from-[#C5A059]/50 to-transparent ml-4"></div>
        </div>

        {/* GRILLA DE NOTICIAS */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
          {noticiasRestantes.map((noticia) => (
            <article 
              key={noticia.id} 
              onClick={() => setNoticiaActiva(noticia)}
              className="group bg-[#0a0a0a] border border-white/5 flex flex-col cursor-pointer overflow-hidden hover:border-[#C5A059]/30 transition-all duration-300 shadow-lg"
            >
              <div className="w-full aspect-video bg-gray-900 overflow-hidden border-b border-white/5 relative">
                <img 
                  src={noticia.foto_url || "https://images.unsplash.com/photo-1507676184212-d0350eb05dda?w=600"} 
                  alt={noticia.titulo} 
                  className="w-full h-full object-cover opacity-60 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
                />
                <div className="absolute top-4 left-4">
                  <span className="text-[#050505] text-[9px] tracking-[0.2em] uppercase bg-[#C5A059] px-3 py-1 font-semibold shadow-md">Noticia</span>
                </div>
              </div>
              
              <div className="p-6 md:p-8 flex flex-col flex-grow">
                <span className="text-gray-500 text-[10px] tracking-widest uppercase font-mono mb-4 block">
                  {formatearFecha(noticia.fecha_creacion)}
                </span>
                
                <h4 className="font-serif text-xl text-gray-200 mb-4 group-hover:text-white transition-colors leading-snug">
                  {noticia.titulo}
                </h4>
                
                <p className="text-gray-400 font-light text-sm leading-relaxed flex-grow line-clamp-3">
                  {obtenerResumen(noticia.articulo)}
                </p>
                
                <div className="mt-6 pt-4 border-t border-white/5 flex justify-end">
                  <span className="text-xs text-[#C5A059] uppercase tracking-widest group-hover:text-white transition-colors">Leer más +</span>
                </div>
              </div>
            </article>
          ))}
        </div>

      </section>
    </div>
  );
};

export default Noticias;